import { SbBlokData } from "@storyblok/js";
import { getStoryFromGlobalStoryblokStoriesBySlug } from "../../utils/global-story-functions";
import { useGlobalStoryblokStories } from "../../utils/with-global-story";
import { StoryblokComponent } from "@made-people/grease-storyblok";

export const MMTrustLogos = ({ maxLogos }: { maxLogos?: number } = {}) => {
  const globalStoryblokStories = useGlobalStoryblokStories();
  const partnerLogosStory = getStoryFromGlobalStoryblokStoriesBySlug(
    "shared-content/partner-logos/partner-logos",
    globalStoryblokStories,
  );

  const logos = partnerLogosStory?.logos;

  if (!logos || logos.length === 0) {
    return null;
  }

  return logos.map((component: SbBlokData, index: number) => {
    const blok =
      maxLogos && Array.isArray(component.logos)
        ? { ...component, logos: component.logos.slice(0, maxLogos) }
        : component;

    return <StoryblokComponent key={index} blok={blok} />;
  });
};
